import { put, call, takeLatest, delay, select } from "redux-saga/effects";
import { ErrorHandler } from "../../utils/errorHandler";
import * as actions from "./actions";
import { addImages, getImages } from "./services";
//getting categories from the shared
function* __GET_IMAGES(action) {
  try {
    const res = yield getImages(action.payload.data);
    const data = res?.data;
    yield put(actions.set_images(data?.files));
    action.payload.cb(data);
  } catch (e) {
    console.log("***********");
    console.log(e);
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.failure(errorMessage);
  }
}

export function* get_images() {
  yield takeLatest(actions.GET_IMAGES, __GET_IMAGES);
}

// payload = {images: [{image_extension: 'png', alt: 'image', base64Code: 'basecode string'}]}
function* __ADD_IMAGES({ payload }) {
  try {
    const res = yield addImages(payload);
    console.log(res);
    yield put(actions.get_images());
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    console.log(errorMessage);
    yield put(actions.set_error({ error: errorMessage }));
  }
}

export function* add_images() {
  yield takeLatest(actions.ADD_IMAGE_TO_LIBRARY, __ADD_IMAGES);
}
